import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useContext } from "react"
import {  useNavigate } from "react-router-dom"
import { LayoutContext } from "../../context"
import { Button } from "@nextui-org/react"

function SideNavItem({ navItem }) {
  const navigate=useNavigate()
  const { setShowSideNav } = useContext(LayoutContext)

  const handleSidenav = () => {
    navigate(navItem.url)
    setShowSideNav(false)
  }

  return (
    <li> 
      <Button
        color="default"
        variant="light"
        onClick={handleSidenav}
        startContent={<FontAwesomeIcon icon={navItem.icon} />}
        className="w-full flex justify-start text-medium"
      >
        {navItem.name}
      </Button>
    </li>
  )
}

export default SideNavItem
